import { useParams } from "react-router-dom";
import { DashboardLayout } from "@/pages/Dashboard";
import { useLanguage } from "@/App";
import ChatSurface from "@/components/community/ChatSurface";
import BackBar from "@/components/BackBar";

export default function CommunityGroup() {
  const { slug } = useParams();
  const { t } = useLanguage();
  return (
    <DashboardLayout title={t("المحادثة", "Chat")}>
      <BackBar
        to="/community"
        label_ar="مجموعات المجتمع"
        label_en="Community Groups"
        crumbs={[
          { to: "/dashboard", ar: "الرئيسية", en: "Home" },
          { to: "/community", ar: "المجتمع", en: "Community" },
          { ar: "المجموعة", en: "Group" },
        ]}
      />
      <ChatSurface slug={slug} />
    </DashboardLayout>
  );
}
